import { type ReactNode, type SVGProps } from 'react';

/**
 * Os seis ícones do portal (DESIGN-FOUNDATION §3.5) — traçados do `lucide`
 * (ISC), inline para não carregar uma dependência só por seis glifos. Traço
 * 1.5px, 20px, `currentColor`. **Ícone nunca marca seção** — só ação ou status.
 * Mais o glifo do WhatsApp, que não existe no lucide (SVG monocromático próprio).
 */

function Base({ children, ...rest }: SVGProps<SVGSVGElement> & { children: ReactNode }): ReactNode {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconeCopiar = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
  </Base>
);

export const IconeCheck = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <path d="M20 6 9 17l-5-5" />
  </Base>
);

export const IconePresente = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13" />
    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
  </Base>
);

export const IconeLocal = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </Base>
);

export const IconeRelogio = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </Base>
);

export const IconeSeta = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <Base {...p}>
    <path d="m9 18 6-6-6-6" />
  </Base>
);

/** Glifo do WhatsApp — monocromático, herda `currentColor` (DESIGN-FOUNDATION §5.5). */
export const GlifoWhatsApp = (p: SVGProps<SVGSVGElement>): ReactNode => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden
    focusable="false"
    {...p}
  >
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.004c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 1.67c2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.42 5.83c0 4.54-3.7 8.24-8.25 8.24a8.24 8.24 0 0 1-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24ZM8.53 6.98c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1s.9 2.43 1.03 2.6c.13.17 1.76 2.8 4.35 3.82 2.15.85 2.59.68 3.06.64.47-.04 1.51-.62 1.72-1.21.21-.6.21-1.11.15-1.22-.06-.11-.23-.17-.48-.3-.25-.13-1.51-.75-1.74-.83-.23-.09-.4-.13-.57.13-.17.25-.65.83-.8 1-.14.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.75-.67-1.25-1.49-1.4-1.74-.14-.25-.01-.39.11-.51.11-.11.25-.29.38-.44.12-.14.16-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.55-1.38-.78-1.88-.2-.44-.42-.45-.6-.46l-.5-.01Z" />
  </svg>
);
